import ageRangeConfig from "../../../config/age_ranges.json"

type AgeRangeConfig = (typeof ageRangeConfig.ranges)[number]
export type AgeRangeKey = AgeRangeConfig["key"]
export type AgeRangeValue = AgeRangeConfig["value"]

export const AGE_RANGES = ageRangeConfig.ranges.reduce<Record<AgeRangeKey, string>>((acc, range) => {
  acc[range.key] = range.label
  return acc
}, {} as Record<AgeRangeKey, string>)

export const AGE_RANGE_VALUES = ageRangeConfig.ranges.map(range => range.value) as AgeRangeValue[]

export const AGE_RANGE_DB_MAPPING = ageRangeConfig.ranges.reduce<Record<AgeRangeKey, AgeRangeValue>>((acc, range) => {
  acc[range.key] = range.value
  return acc
}, {} as Record<AgeRangeKey, AgeRangeValue>)

// Helper functions
export const getAllAgeRangeOptions = (): Array<{ key: string; label: string; value: string }> => {
  return Object.entries(AGE_RANGES).map(([key, label]) => ({
    key,
    label,
    value: AGE_RANGE_DB_MAPPING[key as keyof typeof AGE_RANGE_DB_MAPPING],
  }))
}

export const getAgeRangeLabels = (ageRanges: string[]): string[] => {
  if (!ageRanges || ageRanges.length === 0) return []

  // Convert database values back to labels
  const reverseMapping = Object.entries(AGE_RANGE_DB_MAPPING).reduce((acc, [key, value]) => {
    acc[value] = AGE_RANGES[key as keyof typeof AGE_RANGES]
    return acc
  }, {} as Record<string, string>)

  return ageRanges.map(dbValue => reverseMapping[dbValue]).filter(Boolean)
}

export const isAllAgeRangesSelected = (selectedRanges: string[]): boolean => {
  return selectedRanges.length === AGE_RANGE_VALUES.length && AGE_RANGE_VALUES.every(value => selectedRanges.includes(value))
}
